import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { restaurantInfo, openingHours } from '../../data/mock';

const ContactSection = () => {
  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-wider text-[#C67C4E] uppercase mb-4">
            Visit Us
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-[#1B4332] mb-6">
            Get In Touch
          </h2>
          <p className="text-lg text-[#636E72] max-w-2xl mx-auto">
            We&apos;d love to hear from you. Book a table or drop by for an unforgettable Italian dining experience.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            {/* Address */}
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-[#1B4332] rounded-full flex items-center justify-center flex-shrink-0">
                <MapPin size={24} className="text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-xl text-[#1B4332] mb-2">Our Location</h3>
                <p className="text-[#636E72]">{restaurantInfo.address}</p>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-[#1B4332] rounded-full flex items-center justify-center flex-shrink-0">
                <Phone size={24} className="text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-xl text-[#1B4332] mb-2">Phone</h3>
                <a
                  href={`tel:${restaurantInfo.phone}`}
                  className="text-[#636E72] hover:text-[#C67C4E] transition-colors"
                >
                  {restaurantInfo.phone}
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-[#1B4332] rounded-full flex items-center justify-center flex-shrink-0">
                <Mail size={24} className="text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-xl text-[#1B4332] mb-2">Email</h3>
                <a
                  href={`mailto:${restaurantInfo.email}`}
                  className="text-[#636E72] hover:text-[#C67C4E] transition-colors"
                >
                  {restaurantInfo.email}
                </a>
              </div>
            </div>

            {/* Opening Hours */}
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 bg-[#1B4332] rounded-full flex items-center justify-center flex-shrink-0">
                <Clock size={24} className="text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-xl text-[#1B4332] mb-4">Opening Hours</h3>
                <ul className="space-y-2">
                  {openingHours.map((item) => (
                    <li key={item.day} className="flex justify-between text-[#636E72] min-w-[250px]">
                      <span>{item.day}</span>
                      <span>{item.hours}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Card */}
          <div className="bg-[#1B4332] rounded-3xl p-8 sm:p-12 flex flex-col justify-center items-center text-center">
            <h3 className="font-serif text-3xl sm:text-4xl font-bold text-white mb-4">
              Ready for an Italian Feast?
            </h3>
            <p className="text-white/80 text-lg mb-8 max-w-md">
              Book your table now and experience the authentic taste of Italy at La Pasteria Pizza Bar.
            </p>
            <Link to="/booking">
              <Button className="btn-terracotta text-lg px-8 py-4 h-auto">
                Book a Table
                <ChevronRight size={20} className="ml-2" />
              </Button>
            </Link>
            <p className="text-white/60 mt-6 text-sm">
              Or call us at{' '}
              <a href={`tel:${restaurantInfo.phone}`} className="font-semibold text-[#C67C4E] hover:underline">
                {restaurantInfo.phone}
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
